export default {
  home: '主页',
  aboutUs: '关于我们',
  productService: '产品与服务',
  claims: '索偿',
  questions: '常见问题',
  contactUs: '联系我们',
  privacyPolicy: '隐私政策',
  termsUse: '使用条款',
  login: '登录',
  copyRight: function() { return '版权所有 © ' + new Date().getFullYear() + ' Assura Asia 保留所有权利'; },
  checkmore: '了解更多',
  slogan: ['医学美容风险性解决方案', '让您在意外发生之际仍能从容应对'],
  contact: '在线联系',
  back: '返回',
  userName: '用户名',
  account: '账号',
  email: '邮箱',
  password: '密码',
  scroll: '浏览更多',
  backtohome: '返回首页',
  iknowle: '我知道了',
  backtotop: '回到顶部',

  // 首页
  home_aboutUs: '关于我们',
  home_aboutUs_desc: '艾修美保（Assura Asia）是瑞士 Assura 集团于 2025 年成立的面向亚太地区的全资附属公司，专注为医学美容机构和个人提供优质的综合保障方案，是亚太领先的创新型专属保险企业。',
  home_productService: '产品与服务',
  home_productService_desc: '我们设计并推行更具人性化的保障选项，更好的预防和弥补可能存在的意外和风险。同时， 有效的推动亚太医学美容行业的高质量发展，亦是我们的重要使命之一。',
  home_policyExchange: '保单兑换',
  home_claims: '索偿',
  home_claims_desc: '无论何时何地，您都可以通过我们的在线平台或者专属顾问为您开启便捷及高效的理赔程序。',

  // 关于我们
  aboutus_aboutUs: '关于我们',
  aboutus_aboutUs_desc: `艾修美保 (Assura Asia) 是瑞士 Assura 集团于 2025 年成立的面向亚太地区的全资附属公司，
专注为医学美容机构和个人提供优质的综合保障方案，是亚太领先的创新型专属保险企业。

近年来，随着医学美容技术的发展及趋于成熟化，我们的业务迅速增长。
艾修美保通过持续的优化产品结构与服务，从而为现有及潜在的客户提供更具安全及高效的保障。`,

  aboutus_mission: '宗旨和价值观',
  aboutus_mission_desc: `我们的宗旨和价值观不仅仅体现在对外业务和内部管理上
一直以来, 由内而外的<em>相互尊重</em>和<em>不断追求卓越的精神</em>是艾修美保的核心基石`,
  aboutus_mission_1_title: `尊客第一`,
  aboutus_mission_1_desc1: `客户的满意,等同于我们的成功。`,
  aboutus_mission_1_desc2: `在任何情况下,更好的倾听客户的述求并提供有效的支持,是我们最根本的业务原则。`,
  aboutus_mission_2_title: `处事客观`,
  aboutus_mission_2_desc1: `任何事态都有多面性和复杂性。`,
  aboutus_mission_2_desc2: `我们以客观持平的态度审视业务中的每个机会和风险，从而使每个决定与结论更具人性化和合理化。`,
  aboutus_mission_3_title: `上下一心`,
  aboutus_mission_3_desc1: `我们尊重每一位成员。`,
  aboutus_mission_3_desc2: `我们深刻理解优秀的企业离不开团队的和谐与努力，通过创造由精英主导的优良工作环境，让人才获享更平等与舒适的发展机会。`,
  aboutus_mission_4_title: `尽责公民`,
  aboutus_mission_4_desc1: `我们为成为一名良好企业公民而自豪，致力于回馈社会。`,
  aboutus_mission_4_desc2: `支持不同类型的社会活动。 我们的战略调整标志着艾修美保在亚洲市场的新定位，即使在不就的将来会遇到更多未知的挑战，我们仍将全力以赴。`,

  aboutus_leadership: '管理层简介',
  aboutus_leadership_desc: `我们与经验丰富的同事共同面对各种未知的挑战
最大化的<em>创造预期的社会价值</em>`,
  aboutus_leadership_1_name: ['Bharat W. Lester', '理思贝'],
  aboutus_leadership_1_poi: '首席执行官',
  aboutus_leadership_1_desc: `理思贝先生为艾修美保的首席执行官，他拥有超过20年的保险行业经验，自2025年起理思贝先生参与组建及执行瑞士总部在亚太地区的业务与发展。在加入瑞土总公司之前,他曾任职于瑞士国家科学研究基金会(SNSF)从事医学美容方向的各项营运与管理工作并在随后加入信诺环球与及保诚保险等公司积累了大量的高级管理经验。
  `,
  aboutus_leadership_2_name: ['Max Lee', '李景洪'],
  aboutus_leadership_2_poi: '首席风险官',
  aboutus_leadership_2_desc: `李景洪先生为艾修美保的首席风险官。负责公司的所有风险管理,合规和法律事务。他于2019年加入公司，在亚太和国际保险市场有超过15年的经验，横跨精算，准备金和财务管控等多个领域。李先生毕业于首尔大学并拥有经济学博士学位。`,
  aboutus_leadership_3_name: ['Cathy Ng', '吴凯欣'],
  aboutus_leadership_3_poi: '首席财务官',
  aboutus_leadership_3_desc: `吴凯欣女士为艾修美保的首席财务官。负责管理和统筹所有的财务汇报，规划及监督工作。她于2015年加入瑞士总部,并兼任公司多间附属公司之董事。她在行业内有超过15年的工作经验。在加入集团之前曾就职于安永会计师事务所任高级管理工作。吴女士毕业于新加坡国立大学获会计学士学位，并获斯坦福大学工商管理硕士学位。`,
  aboutus_leadership_4_name: ['Aaron Lim', '林思云'],
  aboutus_leadership_4_poi: '亚太区业务副总裁',
  aboutus_leadership_4_desc: `林思云先生为艾修美保的亚太区业务副总裁。负责管理公司各项产品及业务开发工作。他于2021年加入公司，在行业内有超过15年的高级管理经验，在此之前林先生任职于爱力根亚太总部，对医疗美容行业有着丰富的人脉及渠道资源。林先生毕业于香港中文大学并拥有学士学位。
`,
  aboutus_leadership_5_name: ['Satomi Nagano', '长野里美'],
  aboutus_leadership_5_poi: '亚太区人力资源副总裁',
  aboutus_leadership_5_desc: `长野女士为艾修美保的亚太区人力资源副总裁，负责推动人力资源策略以实现发展目标。她于2025年加入公司，在公司的营运，研发，业务发展等人力资源层面为公司创造了重要价值，并持续的为亚太各区域分公司发掘并提升最有价值的候选人及业务伙伴。长野女士毕业于东京大学并拥有工商管理学位。`,

  aboutus_corporate: '企业社会责任',
  aboutus_corporate_desc: `一直以来，
  艾修美保通过为更多患者和企业降低风险，
  促进行业繁荣发展。
  同时，我们亦积极推动公司内外部的伙伴
  用更多的爱心和关怀让这个世界<em>变得更美好</em>。`,
  aboutus_corporate_1_title: `健康扶贫`,
  aboutus_corporate_1_desc: `通过与各方的慈善机构和团队建立长远的合作伙伴关系，致力为这个社会带来更多积极的改变和进步。`,
  aboutus_corporate_2_title: `社区关怀`,
  aboutus_corporate_2_desc: `通过支持教育、环境保护、医疗健康、志愿服务等方式，提升社区的整体福祉。`,
  aboutus_corporate_3_title: `环境保护`,
  aboutus_corporate_3_desc: `通过减少污染、节约资源、推动可持续发展和绿色能源项目来降低对环境的负面影响。`,

  aboutus_joinus: `加入我们`,
  aboutus_joinus_title: `加入
  我们`,
  mobile_aboutus_joinus_title: `加入我们`,
  aboutus_joinus_intro1: `在亚太地区，艾修美保的业务遍及新加坡，中国香港，印尼，马来西亚，泰国，韩国及日本; 我们计划在不久的将来布局更多国家及地区，为此拥有更多优秀的人才是使公司继续前进的关键。

在这里，我们长期通过各人力资源渠道寻找合适的候选人，除了最基本的岗位经验和经历以外，我们 理想的候选人还应该具备出色的沟通技巧，有效的写作能力及优秀的团队协作能力。`,
  aboutus_joinus_intro2: `* 艾修美保是一个机会均等的雇主。我们不会歧视所有合格的求职者，无论种族、肤色、宗教信仰、宗教、性别、怀孕、国籍、血统、公民身份、年龄、婚姻或伴侣关系状况、性取向、性别认同表达、残疾、医疗状况、遗传信息或倾向、退伍军人或军人身份、家庭暴力受害者的身份，或受法律保护的任何其他类别。我们遵守所有适用法律，为申请人提供合理的残疾便利(若需)。
  
  <span class="bold">若想了解或咨询相关第三方平台在招或开放岗位，请随来信附上您的个人详细简历。</span>
<span class="link">career@assuraasia.com</span>`,

  // 产品与服务
  productservice_productService: `产品与服务`,
  productservice_productService_desc: `医学美容手术是当今最有效改善容貌及形体的医疗技术，因其不可避免的对肌肤存在侵入性及创伤性，在达到美化或改善身体的同时，也存在各种潜在的意外。

我们设计并推行更具人性化的保障选项，更好的预防和弥补可 能存在的意外和风险。 同时，有效的推动亚太医学美容行业的高质量发展，亦是我们的重要使命之一。`,

  productservice_coveragePlans: `保障计划`,
  productservice_coveragePlans_person: `术前意外保障`,
  productservice_coveragePlans_person_desc: `通过卓越的承保方案，深刻的市场洞察和丰富的临床经验，在不能预计的意外发生时，给予有效保障。`,
  productservice_coveragePlans_unit: `机构责任保障`,
  productservice_coveragePlans_unit_desc: `通过创新的服务与产品相结合，优化医疗企业与患者的沟通与满意度，避免机构因意外产生的名誉与经济损失。`,

  productservice_partners: `合作伙伴`,
  productservice_partners_axa: `安盛保险`,
  productservice_partners_nissay: `生命保险`,
  productservice_partners_hsbc: `汇丰保险`,
  productservice_partners_sl: `英伟杰保险`,
  productservice_partners_aia: `友邦保险`,

  // 索偿
  claims_claims: `索偿`,
  claims_claims_desc: `无论何时何地，您都可以通过我们的在线平台或者专属顾问为您开启便捷及高效的理赔程序。

我们务求以最快的速度处理您的申请，向您送上真诚的慰问与关怀。`,

  claims_application_inquiry: `索偿申请及查询`,
  claims_application_inquiry_desc: `快速提交索赔申请并随时查询进度，为您提供便捷的在线自助服务和专属顾问支持，保障您的权益。`,
  claims_application_inquiry_method1_title: `在线自助服务`,
  claims_application_inquiry_method1_desc: `随时随地的掌握您的索偿需求及进展，
化繁为简。`,
  claims_application_inquiry_method2_title: `专属顾问服务`,
  claims_application_inquiry_method2_desc: `通过在线联系平台，第一时间与我们的客服沟通您的需求。`,
  claims_application_inquiry_login: '登录使用',

  // 常见问题
  faq_faqs: '常见问题', // 'FAQs',
  faq_faqs_desc: `解答关于医美保险的常见问题，帮助您轻松了解索赔流程、保单权益及服务细节。

想要了解更多？ 通过在线联系表格立即沟通需求。`,
  faplist: [
    {
      question: `什么是医学美容? 主要分为哪些类别?`,
      ans: `医学美容是指通过手术、药物、医疗仪器以及其它具有创伤性、侵入性或非侵入性的医学技术，对人体的容貌或各部位形态进行美化、改善、修复与再生的美容方式。
  
  从医学角度来说，医学美容主要分为侵入性美容 (整形) 及 非侵入性美容 (轻医美/微整形) 两种，侵入性美容包括: 隆胸、抽脂、隆鼻、眼部整形等手术式美容手段; 非侵入性美容则包括: 镭射光疗、电波拉皮、微整形注射等非手术式美容。`},
    {
      question: `在选择做医学美容手术之前应做好哪些准备?`,
      ans: `一般来说，在手术之前，我们建议做好以下各环节和工作:
  
  1. 详细咨询: 结合自身的现状和需求，予专业的医疗机构进行全方位的咨询和了解
  
  2. 心理建设: 在生活及事业中，对于可能因手术调整而产生的潜在变化或影响有一定的准备和认知
  
  3. 机构选择: 从医疗资质，市场口碑，医师经验，服务，价格等综合维度来选择适合自己的医学美容机构
  
  4. 手术时间规划: 有计划的安排手术及术后恢复所需要的时间; 避开怀孕、哺乳或月经等周期
  
  5. 术前检查充足: 通过常规身体各项检测排除不必要的术前风险，如高血压、心脏病、凝血障碍等
  
  6. 签订手术协议: 确认医疗机构对手术的严谨性，且为自身争取相应的法律保障
  
  7. 申购保险产品: 使意外发生时能得到一定的补偿和保障，从而能更好的面对突如其来的医疗开支和心理落差`,
    },
    {
      question: `什么是核保? 核保有什么主要流程?`,
      ans: `在投保时，保险公司也要先计算自身承保的风险，而保险公司评估风险的过程，就是核保。
  
  一般而言，保险公司会收集投保人的个人健康相关的资料，例如过往医史，照片等，并进行相应的风险评估及留档，再决定是否承保及可提供的保障范围。`,
    },
    {
      question: `什么是快速核保/FastPass?`,
      ans: `在一些特定国家或地区，我们根据大数据的判断和经验，可接受简化的核保程序，大大节省了整个投保时间。
  
  投保人只需在申请时，按照系统或官方问卷答复一些简单的个人资料，包括年龄、性别、居住地等，再回答一些健康问题，例如过往医史等; 最快5分钟便可完成申请，无需再提供特定的健康证明.
  
  由于整个网上投保遵从最高诚信原则及程序自动化，投保人相较常规流程会更快的确认保单批核。`,
    },
  
    {
      question: `为什么投保时需要填写健康问卷?`,
      ans: `公司会根据客户的身体健康状况，对客户的预期死亡率、残疾率及其他保险事故预期发生率进行分类、筛选，进而决定是否承保及承保条件。 而客户健康状况信息的主要资料来源是各类健康问卷. 因此，客户投保时应该如实填写健康问卷，并完成健康问卷中各类问题的告知.`,
    },
    {
      question: `什么是最高诚信原则?`,
      ans: `最高诚信原则是指保险公司相信投保人在核保时已真实准确地披露个人情况及健康现状。 如保险公司日后发现投保人隐瞒或未披露相关重要资料，有权拒绝受理其索偿申请，甚至终止保单.`,
    },
    {
      question: `为什么会核保失败?`,
      ans: `如保险公司在核保程序中判断为该投保人提供保障的风险过高，超出可承受范围，即存在拒保的可能性。`,
    },
    {
      question: `我怎么样可以得知索偿进度和记录?`,
      ans: `通过登入本网站个人客户后台系统，在选单列选择 > 索偿记录，即可查询进度与记录。
  
  当然，您亦可通过直接联系您的专属顾问了解最新进度，或致电我司寻求相关咨询。`,
    },
    {
      question: `我会怎样收到理赔金?`,
      ans: `我们会根据您在索偿表格付款指令中所选择的方式支付理赔金。 如未有指明或所选择的付款方式无法使用时，我们会按照个人账户预设的付款方式进行支付。`,
    },
    {
      question: `触发理赔时，哪些参保对象是符合资格提出索偿的?`,
      ans: `一般而言，索偿可由保单持有人或受保人提出; 而 "身故索偿" 则可由受益人提出。`,
    },
    {
      question: `处理索偿一般需要多久`,
      ans: `在收到有关索偿表格内列明的所需文件后，我们一般会在5至10个工作日交代理赔结果或进度。 我们承诺会尽快处理每一项索偿，但实际所需时间视乎索偿的类别、个案的复杂程度以及所提交资料是否齐全等因素而异。`,
    },
    {
      question: `如何定义术后损伤及预期效果差异?`,
      ans: `您可通过咨询您的专属顾问或合作医疗机构索取相关保单条款; 亦可登入本网站个人客户后台系统，在个人保单页面，查询有关细节。`,
    },
    {
      question: `如何查阅保单文件?`,
      ans: `保单生效后，您可登入本网站个人客户后台系统，在个人保单页面，查询有关细节。`,
    }
  ],

  // 联系我们
  contactus_contactUs: '联系我们',
  contactus_contactUs_desc: `我们期待为您解答任何问题或疑问，
并将尽快回复您的消息。`,
  contactus_inquiryType: `咨询类型`,
  contactus_inquiryType1: `请选择咨询类型`,
  contactus_inquiryType1Options: [
    '术前意外保障计划咨询',
    '机构责任保障计划咨询',
    '接洽专属顾问',
    '保单权益兑换',
    '业务合作',
    '媒体关系',
    '投诉及建议',
    '其它'
  ],
  contactus_countryOptions: [
    '新加坡',
    '日本',
    '韩国',
    '马来西亚',
    '泰国',
    '中国大陆',
    '中国香港',
    '中国澳门',
    '其他地区',
  ],
  contactus_countryCodeOptions: [
    '+65',
    '+81',
    '+82',
    '+60',
    '+66',
    '+86',
    '+852',
    '+853',
  ],
  reset_countryCodeOptions: [
   '+65',
    '+81',
    '+82',
    '+60',
    '+66',
    '+86',
    '+852',
    '+853',
    '其他',
  ],
  contactus_inquiryType2: `请输入您想咨询的问题`,
  contactus_contactInformation: `联系方式`,
  contactus_contactInformation1: `名字`,
  contactus_contactInformation2: `姓氏`,
  contactus_contactInformation3: `先生`,
  contactus_contactInformation4: `女士`,
  contactus_contactInformation5: `国家`,
  contactus_contactInformation6: `城市`,
  contactus_contactInformation7: `国际电话区号`,
  contactus_contactInformation8: `手机号`,
  contactus_submit_protocol: `点击下方按钮即表示您同意我们的<a href="/protocol/private">《隐私政策》</a>和<a href="/protocol/term" class="tp">《使用条款》</a>`,
  contactus_submit: `发送`,
  result_feedback: `感谢您的留言
我们会在审核留言信息后的第一时间与您取得联络`,
  error_required_cannot_empty: '必填项不能为空',

  contactus_offices: '亚太区办事处',
  contactus_offices_list: [
    { 
      name: '新加坡', 
      address: `滨海湾金融中心2座39层`, 
      contact: '+65 6565 7722', 
      email: 'sg@assuraasia.com' 
    },
    { 
      name: '日本', 
      address: `东京市丸之内信托大厦主楼20层`, 
      contact: '+83 03 5288 6288', 
      email: 'jp@assuraasia.com' 
    },
    { 
      name: '韩国', 
      address: `首尔市首尔金融中心21层`, 
      contact: '+82 2 3888 6789', 
      email: 'kr@assuraasia.com' 
    },
    { 
      name: '中国香港', 
      address: `香港中环广场35层`, 
      contact: '+852 6567 6688', 
      email: 'hk@assuraasia.com' 
    },
  ],

  // 保障计划
  plan_person: `术前意外保障计划`,
  plan_person_desc: `通过卓越的承保方案， 深刻的市场洞察和丰富的临床经验， 在不能预计的意外发生时， 给予有效保障。`,
  plan_unit: `机构责任保障计划`,
  plan_unit_desc: `通过创新的服务与产品相结合， 优化医疗企业与患者的沟通与满意度， 避免机构因意外产生的名誉与经济损失。`,
  plan_btn_applynow: `即刻申请`,
  plan_btn_manual: `产品手册`,
  
  plan_coverage: `保障范围`,
  plan_coverage_1: `脸形调整`,
  plan_coverage_2: `鼻综合`,
  plan_coverage_3: `眼综合`,
  plan_coverage_4: `胸部美化`,
  plan_coverage_5: `脂肪管理`,
  
  plan_person_coverage_list_1_title: `意外身亡`,
  plan_person_coverage_list_1_desc: `保障因医疗美容过程中的意外事故导致的身亡风险，为家属提供经济支持，减轻突发事件带来的压力。`,
  plan_person_coverage_list_2_title: `功能性损伤`,
  plan_person_coverage_list_2_desc: `覆盖因医美手术导致的功能性损伤，包括身体机能受损的赔偿，确保客户在遭遇意外时能够得到应有的保护。`,
  plan_person_coverage_list_3_title: `手术事故`,
  plan_person_coverage_list_3_desc: `针对手术过程中的意外情况提供保障，涵盖医疗失误或设备故障引发的伤害，保障客户的合法权益。`,
  plan_person_coverage_list_4_title: `量化满意度`,
  plan_person_coverage_list_4_desc: `通过定期评估客户满意度，确保服务质量，及时反馈与调整，致力于为客户提供更优质的医美体验。`,

  plan_unit_coverage_list_1_title: `医疗责任保障`,
  plan_unit_coverage_list_1_desc: `保障因治疗或手术意外导致患者身亡的责任赔偿和善后费用，并支持遗属安抚及舆情处理，帮助机构减少影响。`,
  plan_unit_coverage_list_2_title: `功能性损伤`,
  plan_unit_coverage_list_2_desc: `覆盖因医美手术导致的功能性损伤，包括身体机能受损的赔偿，确保客户在遭遇意外时能够得到应有的保护。`,
  plan_unit_coverage_list_3_title: `手术事故`,
  plan_unit_coverage_list_3_desc: `针对手术过程中的意外情况提供保障，涵盖医疗失误或设备故障引发的伤害，保障客户的合法权益。`,
  plan_unit_coverage_list_4_title: `量化满意度`,
  plan_unit_coverage_list_4_desc: `通过定期评估客户满意度，确保服务质量，及时反馈与调整，致力于为客户提供更优质的医美体验。`,

  plan_features: `计划特色`,
  plan_person_features_1_title: `快速核保`,
  plan_person_features_1_desc: `在线申请服务，
快速核保。`,
  plan_person_features_2_title: `私人专属顾问`,
  plan_person_features_2_desc: `一对一专业咨询，
客观建议方案。`,
  plan_person_features_3_title: `可定制化保单`,
  plan_person_features_3_desc: `灵活选择保障内容，
为您量身所订。`,
  plan_person_features_4_title: `海外医疗礼宾服务`,
  plan_person_features_4_desc: `亚太区医疗多重资源，
随时提供所需支持。`,

  plan_unit_features_1_title: `FASTPAY™️`,
  plan_unit_features_1_desc: `在线申请索偿，
快速赔付到账。`,
  plan_unit_features_2_title: `提升综合背书`,
  plan_unit_features_2_desc: `增强患者的信任度，
提升医疗机构的多元化服务能力。`,
  plan_unit_features_3_title: `转移业务风险`,
  plan_unit_features_3_desc: `有效应对意外发生，
降低经营压力。`,
  plan_unit_features_4_title: `专属团队支持`,
  plan_unit_features_4_desc: `专业的各项支持，
高效协同处理风险事故的发生。`,

  plan_moreinfo: `了解更多`,
  plan_moreinfo_desc: `通过在线联系表格 立即沟通需求`,
  plan_moreinfo_slogan: `医学美容风险性解决方案
让您在意外发生之际仍能从容应对`,
  plan_moreinfo_nores: `免责声明`,
  plan_moreinfo_nores_desc: `艾修美保及其相关公司、附属公司和子公司就所有明确和隐含的保证作免责声明，其范围包括但不限于适用产品展示或推荐及其他特殊用途。使用者有责任对所提供的任何观点、建议、服务及其他信息的准确性、完整性和有用性作出评估，或请根据您的个人情况咨询您的法律或医疗等相关专业人士。艾修美保及其相关公司、附属公司和子公司将不对由于使用本公司网站或任何展示资料引起的任何直接的、间接的、特殊的、偶然的和必然的损害负责。`,

  // 登录
  login_loginType: `请选择登录类型`,
  login_loginType_desc: `访问管理您的保障计划或相关业务的最新进展`,
  login_loginType_1_title: '个人客户',
  login_loginType_1_desc: '术前意外保障计划',
  login_loginType_2_title: '企业用户',
  login_loginType_2_desc: '机构责任保障计划',
  login_loginType_3_title: '代理及经纪',
  login_loginType_3_desc: '业务管理',
  login_forget_password_tip: `忘记密码了？`,
  login_forget_password_find: '点此找回',
  login_forget_password_find_desc: '请输入您的邮箱地址，我们将发送一封邮件，帮助您重置密码。',
  login_noaccount_tip: `暂无账号?`,
  login_regsiter_now: '即刻注册',
  login_error_account: '用户名或邮箱错误，请重试',
  login_error_password: '密码错误，请重试',

  // 兑换
  exchange_title: '保单权益兑换',
  exchange_welcome_txt: '欢迎回来，Oli',
  exchange_loginType_1_title: '卡密信息',
  exchange_loginType_1_plsholder: '密钥',
  exchange_loginType_1_error: '密钥错误，请重试',
  exchange_description_title: '兑换说明',
  exchange_description_txt: ` · 兑换卡在成功绑定后，不能解绑，不能跨账户使用。
 · 兑换卡绑定后，请前往个人中心兑换相应的权益保单。
 · 若有其他问题，请联系在线客服或您的专属顾问。`,
  exchange_btn: '兑换权益',

  // 注册
  register_title: '账户信息',
  register_account: '账号:',
  register_account_tip: '3-20字符，含字母/数字/下划线',
  register_account_exist: '账号已存在，请重试',
  register_email:'邮箱:',
  register_email_tip: '请仔细检查邮箱格式是否正确',
  register_email_exist: '邮箱已存在，请重试',
  register_password: '设置密码:',
  register_password_tip: '至少7位，含大小写字母和数字',
  register_password_tip_mobile:`至少 7 个字符</br>至少1个数字、1个大写英文字母，</br>及1个小写英文字母且不包含空格`,
  register_password_again: '确认密码:',
  register_password_again_error: '请保持两次密码输入一致',
  register_promo_code:'邀请码:',
  register_promo_code_error:'邀请码错误',
  next: '下一步',
  register_cancel_btn: '取消',
  placeholder_common: '请输入',

  //找回密码
  reset_password_title: '找回密码',
  reset_password_subtitle: '可通过邮箱或手机验证找回',
  reset_password_menu: '请选择找回密码的方式:',
  reset_password_email: '注册邮箱验证',
  reset_password_mobile:'注册手机号验证',
  reset_no_account: '该账号未注册',

  //cookie
  cookie_accept_title: 'Cookie 设置',
  cookie_accept_context: '点击“接受”即表示您同意在您的设备上存储 Cookie，以增强网站导航、分析网站使用情况并协助我们的营销工作。',
  cookie_accept_btn: '接受',
  cookie_reject_btn: '拒绝'
}